export default "__VITE_ASSET__f6f10f83__"